import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { AgentType } from 'constants/assist/agentType';

export interface WelcomeMessages {
  advancedConfig: boolean;
  default: string | null;
  afterHours: string | null;
  assistOff: string | null;
}

export interface EscalationPhoneNumbers {
  advancedConfig: boolean;
  default: string | null;
  secondary: string | null;
  afterHours: string | null;
  assistOff: string | null;
}

export interface CentsAssistInfo {
  businessPhoneNumber: string;
  welcomeMessages: WelcomeMessages;
  hoursLocationMessage: string;
  servicesPricingMessage: string;
  escalationProtocol: string;
  faqs: string;
  upsellProtocol: string;
  escalationPhoneNumbers: EscalationPhoneNumbers;
  transactionalPhoneNumber: string;
  offersPud: boolean;
  sendOrderLinkViaSms: boolean;
  bypassCallTransferWithEscalation: boolean;
  enableCentsSupport: boolean;
  isLocked: boolean;
  /** Cleared by the backend once a phone number is bound to the agent, so a save can return null. */
  agentId: string | null;
  /** Derived by the backend; read-only unless it is being set to CUSTOM. */
  agentType: AgentType | null;
  supportsCardBalance: boolean;
}

export const getCentsAssistInfo = (businessId: number): AxiosPromise<CentsAssistInfo> => {
  return httpClient({
    method: 'GET',
    url: `/assist/info/${businessId}`,
  });
};
